export const DIRECT_SUBMISSION_ROLES = {
    INITIATOR: 'Direct Submission Initiator',
    APPROVER: 'Direct Submission Approver',
};

export const DIRECT_SUBMISSION_PERMISSIONS = {
    INITIATE: 'directsubmission_initiate',
    APPROVE: 'directsubmission_approve',
};

// IAM-DS condition grammar rejects '*' (RHS must match ^[a-z.A-Z 0-9_-]+$).
// '_all_' is the agreed wildcard token; enforcement reads it as "default access from companyGrants".
export const WILDCARD = '_all_';

export const DEFAULT_CONDITION = `companyId EQ '${WILDCARD}' AND countryCode EQ '${WILDCARD}'`;

export const ALL_COMPANIES_GRANT = '*';
// Max companies in one user's DS scope. Bounded by the IAM grant condition length (4000 chars) and JWT header size.
export const DS_MAX_COMPANIES_PER_USER = 50;
